export enum MutationType {
  Comment,
  Snapshot,
  Task
}
